
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.791","height":"14.193"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32974","data-name":"Path 32974","d":"M11.185 2.12A24.983 24.983 0 015.991.52a.29.29 0 00-.2 0A24.8 24.8 0 01.678 2.101c-.142.027-.177.076-.177.217.008 1.569-.006 3.134.008 4.7a7.752 7.752 0 00.1 1.211 6.734 6.734 0 005.207 5.456.393.393 0 00.16 0 6.762 6.762 0 005.315-6.541V2.271c0-.081-.006-.132-.106-.151zM8.977 5.864L5.812 9.441a1 1 0 01-.746.337h0a1 1 0 01-.744-.332l-1.5-1.673A1 1 0 114.31 6.437l.751.837 2.421-2.736a1.001 1.001 0 011.5 1.326z","fill":"#a3a3a3","stroke":"#a3a3a3","stroke-width":"1"}})])
          )
        }
      }
    